import { useRouter } from 'next/router';
import { useEffect } from 'react';

const CHAT_WIDGET_SCRIPT_ID = 'mindpal-chat-widget-script';
const CHAT_WIDGET_SRC = process.env.NEXT_PUBLIC_CHAT_WIDGET_SRC;
const CHAT_WIDGET_SITE = process.env.NEXT_PUBLIC_CHAT_WIDGET_SITE;
const EXCLUDED_PATH_PREFIXES = [
  '/dashboard',
  '/builder',
  '/jobs',
  '/offers',
  '/candidate-auth',
];

declare global {
  interface Window {
    __MindPalChatLoaded?: boolean;
  }
}

function isExcludedPath(path: string) {
  const cleanPath = path.split('?')[0]?.split('#')[0] || '/';

  return EXCLUDED_PATH_PREFIXES.some(
    (prefix) => cleanPath === prefix || cleanPath.startsWith(`${prefix}/`)
  );
}

function removeWidget() {
  document
    .querySelectorAll<HTMLIFrameElement | HTMLScriptElement>(
      `iframe[data-mindpal-chat], #${CHAT_WIDGET_SCRIPT_ID}`
    )
    .forEach((element) => element.remove());

  delete window.__MindPalChatLoaded;
}

function loadWidget() {
  if (!CHAT_WIDGET_SRC || !CHAT_WIDGET_SITE) return;
  if (window.__MindPalChatLoaded) return;
  if (document.getElementById(CHAT_WIDGET_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = CHAT_WIDGET_SCRIPT_ID;
  script.src = CHAT_WIDGET_SRC;
  script.async = true;
  script.dataset.site = CHAT_WIDGET_SITE;

  document.body.appendChild(script);
}

export default function MindPalChatWidget() {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    if (isExcludedPath(router.asPath)) {
      removeWidget();
      return;
    }

    loadWidget();
  }, [router.asPath, router.isReady]);

  return null;
}
